module.exports = __webpack_public_path__ + "static/media/33.f72a9f46.png";